import axios from 'axios';
import { Message } from 'element-ui';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 30000,
});

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('molv_token');
    if (token) {
      config.headers['molv-token'] = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.errCode !== 0) {
      Message.error(res.errMsg || '请求失败');
      return Promise.reject(res);
    }
    return res;
  },
  (error) => {
    const msg = error.response?.data?.errMsg || error.message || '请求失败';
    Message.error(msg);
    if (error.response?.status === 401) {
      localStorage.removeItem('molv_token');
      window.location.hash = '#/login';
    }
    return Promise.reject(error);
  }
);

export default service;
